module.exports = __webpack_public_path__ + "static/media/successIcon.51cfc84c.svg";